/**
 * EL LOGOTIPO
 * =============================================================================
 * La M dorada y el texto «SOCCER ACADEMY» salen de tu archivo original, con el
 * fondo negro vuelto transparente.
 *
 * -----------------------------------------------------------------------------
 * POR QUÉ SON IMÁGENES Y NO TEXTO
 * -----------------------------------------------------------------------------
 * Antes intenté dibujar la M con vectores y escribir el texto con una tipografía
 * parecida. El resultado era una versión aproximada, nunca la tuya: la M tiene un
 * degradado metálico con brillos que no se pueden reproducir con CSS, y el
 * «SOCCER» lleva un degradado plateado con un corte en diagonal que ninguna
 * tipografía tiene.
 *
 * Así que van los dos como imágenes, recortadas de tu logo. Y se ven idénticos en
 * cualquier tamaño porque se sacaron del original de 1585 px de ancho.
 *
 * -----------------------------------------------------------------------------
 * LAS MEDIDAS
 * -----------------------------------------------------------------------------
 * El ancho lo marca el alto: la M mide 500x440 y el texto 930x205, así que cada
 * uno conserva su proporción sin deformarse.
 */

interface Props {
  /** El alto de la M, en píxeles. El texto se escala con ella. */
  alto?: number;
  /** Si se muestra también «SOCCER ACADEMY». */
  conTexto?: boolean;
  className?: string;
}

export function Logo({ alto = 38, conTexto = false, className }: Props) {
  /* La M mide 500x440 de origen: su ancho es el alto por 1,136. */
  const ancho = Math.round(alto * (500 / 440));
  /* El texto mide 930x205, así que su alto es el ancho por 0,22. */
  const anchoTexto = Math.round(alto * 2.1);

  return (
    <span
      className={'logo' + (className ? ' ' + className : '')}
      style={{ gap: Math.round(alto * 0.22) }}
    >
      <img
        className="logo__m"
        src="./marca/m.png"
        alt={conTexto ? '' : 'M Soccer Academy'}
        width={ancho}
        height={alto}
        style={{ height: alto, width: ancho }}
        /* El logotipo se ve en todas las páginas y es pequeño: conviene que no se
           difiera. */
        loading="eager"
        decoding="async"
      />

      {conTexto && (
        <img
          className="logo__texto"
          src="./marca/logo-texto.png"
          /* El texto no aporta nada nuevo a quien usa un lector de pantalla: ya lo
             dice el `alt` de la M, que está al lado. */
          alt=""
          width={anchoTexto}
          height={Math.round(anchoTexto * (205 / 930))}
          style={{ width: anchoTexto }}
        />
      )}
    </span>
  );
}
